import React from "react";
import styled from "styled-components";
import * as palette from "../Variables";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useForm, ValidationError } from '@formspree/react';
import {keyframes} from "styled-components";

const wiggleAnimation = keyframes`
    0% {transform: rotate(5deg);}
    20% {transform: rotate(-5deg);}
    40% {transform: rotate(4deg);}
    60% {transform: rotate(-3deg);}
    80% {transform: rotate(2deg);}
    100% {transform: rotate(0deg);}
`;

const StyledButton = styled.div`

    button {
    
        padding: 12px 24px;
        border-radius: 8px;
        border: 0;
        background: ${palette.gradientMain};
        background-color: ${palette.pinkMain};
        color: ${palette.neutral1};
        transition: background 250ms ease;
        text-decoration: none;
        display: block;
        font-size: 14px;
        font-weight: 600;

        &:focus {
            background-color: ${palette.orangeMain};
            animation: ${wiggleAnimation} 700ms;
        }

        &:hover {
            background: ${palette.gradient1};
            transition: background 250ms ease;
            cursor: pointer;
            color: ${palette.neutral1};
            animation-name: ${wiggleAnimation};
            animation-duration: 700ms;
        }

        @media (min-width: 768px) {
            font-size: 16px;
        }

    }
`;

const StyledForm = styled.div`

    label {
        font-weight: 600;
        margin-bottom: 8px;
    }

    input {
        width: 100%;
        margin-bottom: 24px;
        background-color: #F2F2F2;
        border: none;
        border-radius: 8px;
        padding: 8px 16px;
    }

    textarea {
        width: 100%;
        height: 160px;
        background-color: #F2F2F2;
        border: none;
        border-radius: 8px;
        padding: 8px 16px;
        resize: none;
        margin-bottom: 24px;
    }
`;

function ContactForm() {
  const [state, handleSubmit] = useForm("mdenjalz");
  if (state.succeeded) {
      return <p>Thanks for reaching out! Your message is on its way to my inbox. I'll get back to you as soon as I can.</p>;
  }
  return (
    <StyledForm>
        <form onSubmit={handleSubmit}>
            <label htmlFor="name">Name</label><br/>
            <input id="name" type="name" name="name"/>
            <label htmlFor="email">Email address</label><br/>
            <input id="email" type="email" name="email"/>
            <ValidationError prefix="Email" field="email" errors={state.errors}/>
            <label htmlFor="message">Message</label><br/>
            <textarea id="message" name="message"/>
            <ValidationError prefix="Message" field="message" errors={state.errors}/>
            <StyledButton><button type="submit" disabled={state.submitting}>Send</button></StyledButton>
        </form>
    </StyledForm>
  );
}

const Form = () => {
    return (
        <ContactForm />
    )
}

export default Form;